module.exports = __webpack_public_path__ + "static/img/linyi-index.eb8bfd50.jpg";